





















































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';
import Header from './components/Header.vue';
import LandingFooter from 'frontend/views/landing/LandingFooter.vue';
import Card from './components/Card.vue';
import StaffMemberItem from './components/StaffMemberItem.vue';
import { MobileGetter } from 'frontend/types';

interface Remembered {
  name: string;
  avatar: string;
}

@Component({
  metaInfo() {
    return {
      title: 'About',
    };
  },
  components: {
    Card,
    StaffMemberItem,
    LandingFooter,
    Header,
  },
  computed: {
    ...mapState('staffMembers', ['staff_members']),
    ...mapGetters('globals', ['isAuthenticated']),
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class About extends Vue {
  private isMobile!: MobileGetter;

  private inMemoriam: Remembered[] = [
    { name: 'Carrie McLaughlin', avatar: 'carrie' },
    { name: 'Kristian Takvam', avatar: 'kristian' },
  ];

  private shouldPrintStaffMemberGridRuler(index: number) {
    return index !== 0 && (index % 3 === 0 || index % 5 === 0);
  }

  private mounted(): void {
    document.body.classList.add('about-page');
  }
}
